import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

@Injectable()
export class ErrorhandlerService {

  constructor(public toastr: ToastrService, private router: Router) { }

  private authFailureMsg(errMsg: string): string {

    let msg;

    switch (errMsg) {
      case 'INVALID_CREDENTIALS':
        msg = 'Username atau password salah';
        break;
      case 'TOKEN_INVALID':
        msg = 'Otentifikasi tidak valid';
        break;
      case 'TOKEN_EXPIRED':
        msg = 'Sesi telah berakhir. Silahkan login lagi';
        break;
    }

    return msg;
  }

  private sqlFailureMsg(code: string): string {
    let msg;

    switch (code) {
      case '23000':
        msg = 'Duplikat dengan data yang sudah ada. Pastikan kolom kode tidak duplikat';
        break;
      default:
        msg = 'Gangguan database dg kode: ' + code;
        break;
    }

    return msg;
  }

  private appPreconditionFailure(errMsg: string) {
    let msg;

    switch (errMsg) {
      case 'PAID_BY_OTHER_METHOD':
        msg = 'Pendaftaran telah dibayar menggunakan metode lain';
        break;
      case 'VALID_PAYMENT_SHALL_NOT_DELETED':
        msg = 'Tidak boleh menghapus pembayaran yg sudah VALID';
        break;
      case 'AUTO_PAYMENT_SHALL_NOT_DELETED':
        msg = 'Tidak boleh menghapus pembayaran yg Auto';
        break;
      default:
        msg = errMsg;
        break;
    }

    return msg;
  }

  errorHttp(err: HttpErrorResponse): void {
    console.error(err);
    let msg = '';

    switch (err.status) {
      case 400:
        msg = 'Data yang dikirim tidak valid';
        break;
      case 401:
        msg = this.authFailureMsg(err.error);
        break;
      case 403:
        msg = 'Otorisasi gagal. Anda tidak memiliki hak akses';
        break;
      case 404:
        msg = 'Data tidak ditemukan';
        break;
      case 405:
        msg = 'Salah metode pengiriman';
        break;
      case 422:
        msg = 'Parameter filter yg diminta tidak valid';
        break;
      case 428:
        msg = this.appPreconditionFailure(err.error);
        break;
      case 500:
        if (err.error.type === 'SQL') {
          msg = this.sqlFailureMsg(err.error.code);
        } else {
          msg = 'Gangguan internal server. Coba beberapa saat lagi';
        }
        break;
      case 503:
        msg = 'Sistem sedang sibuk. Coba beberapa saat lagi';
        break;
      case 0:
        msg = 'Server sedang down. Coba beberapa saat lagi';
        break;
      default:
        msg = 'Error: ' + JSON.stringify(err);
        break;
    }

    this.toastr.error(msg, 'Gagal');

    if (err.status === 401) {
      this.router.navigate(['/login']);
    }
  }

}
